import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './admins.loaders';
import { converters } from './admins.converters';
import { AdminsFilters } from './admins.types';

export const adminsKeys = queryKeyFactory('admins');

export const useAdmins = (filters: Partial<AdminsFilters> = {}) => {
  return useQuery({
    queryKey: adminsKeys.list(filters),
    queryFn: () => loaders.getAdmins({ filters }),
    select: converters.getAdmins,
  });
};

export const useAdmin = (adminId: string) => {
  return useQuery({
    queryKey: adminsKeys.detail(adminId),
    queryFn: () => loaders.getAdmin({ adminId }),
    select: (data) => converters.getAdmin(data),
    enabled: !!adminId,
  });
};
